import { FunctionComponent } from 'react';

// Libs
import classnames from 'classnames';

// Contexts
import { useViewDetected } from '@Components/Utils/ViewDetected';

// Components
import ImgLazy from '@Components/Utils/Lazy/Image';

// Styles
import styles from './HeadContent.module.scss';

interface HeadContentProps {
    className?: string;
}

const HeadContent: FunctionComponent<HeadContentProps> = ({ className }) => {
    const { deviceType } = useViewDetected();

    const isMobile = deviceType !== 'desktop';

    const scrollToForm = () => {
        const element: any = document.querySelector('[name="name"]');
        element.focus();
    };

    const wrapperClassName = classnames([
        styles.wrapper,
        {
            [styles.mobile]: isMobile,
        },
        className,
    ]);

    return (
        <div className={wrapperClassName}>
            <div className={styles.image_wrapper}>
                <ImgLazy width={740} height={590} className={styles.img} src="/assets/cong-tac-vien/head.png" />
            </div>
            <div className={styles.content}>
                <ul className={styles.list_info}>
                    <li className={styles.info}>Bạn là Điều Dưỡng, Y Tá, CTV Xét nghiệm tận tâm?</li>

                    <li className={styles.info}>Bạn mong muốn được nâng cao thu nhập cá nhân?</li>

                    <li className={styles.info}>Bạn sẵn sàng giúp đỡ cộng đồng bảo vệ sức khoẻ?</li>

                    <li className={styles.title}>
                        <span className="text-primary">eDoctor</span> chính là nơi dành cho bạn
                    </li>

                    <li className={styles.action}>
                        <div onClick={scrollToForm} className={styles.button}>
                            Tham gia cộng tác
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    );
};

HeadContent.defaultProps = {
    className: '',
};

export default HeadContent;
